import React from 'react';
import classes from './ShortText.module.scss';
import CheckIcon from '../../../Assests/Icons/CheckIcon';
import ShortTextIcon from '../../../Assests/Icons/ShortTextIcon';

const ShortText = () => {
  return (
    <div className={classes.container}>
      <div className={classes.icon}>
        <ShortTextIcon />
      </div>
      <div className={classes.type_name}>ShortText</div>
    </div>
  );
};

export default ShortText;
